// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as JsxPPXReactSupportU from "rescript/lib/es6/jsxPPXReactSupportU.js";
import * as V3DndBehaviour$LiteracyplanetTupperware from "./V3DndBehaviour.res.mjs";

function PilotClozeDropBucketContainer(props) {
  var children = props.children;
  var limitNumberOfItems = props.limitNumberOfItems;
  var id = props.id;
  if (limitNumberOfItems !== undefined) {
    return React.createElement("div", undefined, props.hasHeader ? React.createElement("div", {
                      className: "pilotClozeChainHeader"
                    }, children) : null, React.createElement("div", {
                    className: "pilotClozeChainGroup"
                  }, Belt_Array.map(Belt_Array.range(1, limitNumberOfItems), (function (index) {
                          var uniqueId = V3DndBehaviour$LiteracyplanetTupperware.makeUniqueIdFromIndex(String(index), id);
                          return JsxPPXReactSupportU.createElementWithKey(uniqueId, V3DndBehaviour$LiteracyplanetTupperware.DropChainItem.make, {
                                      id: id,
                                      uniqueId: uniqueId
                                    });
                        }))));
  } else {
    return React.createElement(V3DndBehaviour$LiteracyplanetTupperware.Drop.make, {
                id: id,
                headerClassname: "pilotClozeBucketHeader PilotClozeDropBucketContainer",
                children: children
              });
  }
}

var make = PilotClozeDropBucketContainer;

var $$default = PilotClozeDropBucketContainer;

export {
  make ,
  $$default as default,
}
/* react Not a pure module */
